const stocks = [{
		path : 'stocks/:code',
		name: 'stocks',
		component: resolve => {
			require(['../views/stock/show.vue'], resolve)
		},
		meta:{
			title:''
		}
},
{
	path : 'material_detail',
	name: 'material_detail',
	component: resolve => {
		require(['../views/stock/material_detail.vue'], resolve)
	},
	meta:{
		title:''
	}
},
{
	path : 'stockList',
	name: 'stockList',
	component: resolve => {
		require(['../views/stock/stockList.vue'], resolve)
	},
	meta:{
		title:''
	}
},
{
	path : 'industry',
	name: 'industry',
	component: resolve => {
		require(['../views/stock/industry.vue'], resolve)
	},
	meta:{
		title:'行业涨幅'
	}
},
{
	path : 'industryList',
	name: 'industryList',
	component: resolve => {
		require(['../views/stock/industryList.vue'], resolve)
	},
	meta:{
		title:''
	}
}
]

export default stocks



// WEBPACK FOOTER //
// ./src/router/stocks.js